import React, { Component } from 'react';
import { connect } from 'react-redux';

import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import { AccentColor } from 'helpers/AccentColorHelper';

import * as siteEventActions from 'actions/siteEventActions';
import * as bookings from 'actions/bookingsActions';

import ShowingSelector from 'components/tenant_app/components/tenant_dashboard/todos/ShowingSelector';
import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';
import MultiSelectExtended from 'components/shared/MultiSelectExtended';
import SearchableSelect from 'components/shared/SearchableSelect';
import Header from 'components/shared/Header';

import {
  getProperties,
  tenants,
  getActiveLeaseOfUnit,
  getAmenities,
  getAmenity,
  selectedTenantID,
} from 'actions/landlordPropertiesActions';

import FlatButton from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { getTranslatedString } from 'helpers/i18n';

const mapStateToProps = (store, ownProps) => {
  return {
    initialValues: ownProps.initialValues,
    amenities: store.landlordProperties.amenities,
    amenity: store.landlordProperties.amenity,
    tenantsForMultiselect: store.landlordProperties.tenants,
    properties: store.landlordProperties.properties,
    units: store.landlordProperties.units,
    unitActiveLease: store.landlordProperties.unitActiveLease,
  };
};

let BookAmenityDialog = class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAmenity: this.props.isAmenity || false,
      selectedProperty: null,
      selectedAmenity: null,
      tenant: null,
      selectedTenantID: null,
      disableOverlayClick: true,
    };
  }

  componentDidMount = () => {
    this.props.getProperties({ for_multiselect: true });
  };

  fetchActiveLeaseOfUnit = unit => {
    this.props.getActiveLeaseOfUnit(unit).then(result => {
      this.props.changeFieldValue('unit_active_lease', result.value);
    });
  };

  onPropertySelect = property => {
    this.setState({ selectedAmenity: null, tenant: null });
    this.props.tenants({
      for_multiselect: true,
      property_id: property.value,
    });
    this.props
      .getAmenities({
        for_multiselect: true,
        property_id: property.value,
      })
      .then(() => {
        this.setState({ selectedProperty: property });
      });
  };

  onAmenitySelect = amenity => {
    this.props.getAmenity(amenity.value).then(() => {
      this.setState({ selectedAmenity: amenity });
    });
  };

  onUnitChange = event => {
    if (!event.value) return;
    this.clearSelections();
    this.fetchActiveLeaseOfUnit(event.value);
  };

  clearSelections = () => {
    this.props.clearActiveLeaseOfUnit();
    this.props.changeFieldValue('tenant', null);
  };

  onAmenitySelect = amenity => {
    this.props.getAmenity(amenity.value).then(() => {
      this.setState({ selectedAmenity: amenity });
    });
  };

  onTenantSelect = tenant => {
    this.props.selectedTenantID(tenant.value);
    this.setState({ tenant: tenant });
  };

  submitBookingForm = vars => {
    this.props.setToIsLoading();
    this.props.removePreviousSearchResults();
    this.props.showAvailableAmenityBookings(
      this.props.amenity.id,
      vars.time,
      vars.date,
      vars.requested_booking_length
    );
  };

  toggleDialog = () => {
    this.props.toggleDialog();
    this.props.removePreviousSearchResults();
    this.props.setToIsLoading(false);
    this.setState({
      isAmenity: false,
      tenant: null,
      selectedProperty: null,
      selectedAmenity: null,
      amenityNotes: null,
    });
  };

  render() {
    const { fullScreen } = this.props;

    const bookEditVerbiage = this.props.initialValues.name
      ? getTranslatedString('landlordPortal.addEventDialog.edit')
      : getTranslatedString('landlordPortal.bookDialog.book');
    const headerVerbiage = getTranslatedString('landlordPortal.addEventDialog.amenity');

    return (
      <div>
        <Dialog
          disableBackdropClick={this.state.disableOverlayClick}
          fullScreen={fullScreen}
          open={this.props.isOpen}
          onClose={this.toggleDialog}
          aria-labelledby="add-new-event"
          classes={{
            paper: 'form-dialog',
          }}
        >
          <DialogTitle id="add-new-survey">
            <h3 style={{ textAlign: 'center', margin: 0 }}>
              {bookEditVerbiage} {headerVerbiage}
            </h3>
          </DialogTitle>
          <DialogContent>
            <div className="row">
              <div className="row" style={{ maxWidth: '350px', margin: 'auto' }}>
                <div className="row" style={{ padding: '20px 0 15px' }}>
                  <MultiSelectExtended
                    onChange={this.onPropertySelect}
                    name="property_select"
                    floatingLabel={getTranslatedString('landlordPortal.addEventDialog.property')}
                    data={this.props.properties}
                    menuStyle={{ fontSize: '14px' }}
                    textFieldStyle={{ padding: 0 }}
                    style={{ fontSize: '14px' }}
                    minHeight={'32px'}
                    fullWidth
                    value={this.state.selectedProperty}
                  />
                </div>
                {this.state.selectedProperty && (
                  <div className="row" style={{ marginTop: '10px' }}>
                    <SearchableSelect
                      name="tenant"
                      data={this.props.tenantsForMultiselect.map(tenant => ({
                        value: tenant.value,
                        label: getTranslatedString(
                          'landlordPortal.addEventDialog.tenantSelect.values',
                          {
                            tenantName: tenant.full_name,
                            unitNumber: tenant.unit_number,
                          }
                        ),
                      }))}
                      label={<TenantResidentVerbiageHelper capitalize />}
                      placeholder={getTranslatedString(
                        'landlordPortal.addEventDialog.tenantSelect.placeHolder'
                      )}
                      menuStyle={{
                        minWidth: '250px',
                        fontSize: '14px',
                      }}
                      style={{ fontSize: '15px' }}
                      fullWidth
                      value={this.state.tenant}
                      onChange={this.onTenantSelect}
                      autoWidth
                    />
                  </div>
                )}
                {this.state.tenant && (
                  <div className="row" style={{ marginTop: '30px', height: '52px' }}>
                    <MultiSelectExtended
                      onChange={this.onAmenitySelect}
                      name="amenity_select"
                      floatingLabel={getTranslatedString('landlordPortal.addEventDialog.amenity')}
                      data={this.props.amenities}
                      menuStyle={{ fontSize: '14px' }}
                      textFieldStyle={{ padding: 0 }}
                      style={{ fontSize: '14px' }}
                      minHeight={'32px'}
                      fullWidth
                      value={this.state.selectedAmenity}
                    />
                  </div>
                )}
              </div>
              {this.state.selectedAmenity && (
                <div className="row" style={{ marginTop: '-15px' }}>
                  {this.renderAmenityNotes()}
                  <ShowingSelector
                    amenityBookingDetails={this.props.amenity}
                    submitForm={this.submitBookingForm}
                    toggleBookingDialog={this.toggleDialog}
                    fullScreen={this.props.fullScreen}
                    onComplete={this.props.onComplete}
                    minDateOverride={new Date()}
                    bookingNotes={this.state.amenityNotes}
                  />
                </div>
              )}
            </div>
          </DialogContent>
          <DialogActions
            style={{
              display: 'block',
              height: '36px',
              padding: '0 10px',
            }}
          >
            <div className="row" style={{ display: 'inline-block', width: '100%' }}>
              <FlatButton
                onClick={this.toggleDialog}
                id="close-button"
                style={{ color: AccentColor() }}
              >
                {getTranslatedString('landlordPortal.addEventDialog.closeUpcase')}
              </FlatButton>
            </div>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  renderAmenityNotes = () => {
    return (
      <div className="row" style={{ margin: '0 -20px' }}>
        <Header name={getTranslatedString('landlordPortal.addEventDialog.bookingNameUpcase')} />
        <div className="row" style={{ maxWidth: '350px', margin: 'auto' }}>
          <div className="col-xs-12" style={{ padding: 0 }}>
            <h5 style={{ marginBottom: '2px' }}>
              {getTranslatedString('landlordPortal.addEventDialog.internalNotes')}
            </h5>
            <TextField
              name="notes"
              type="text"
              onChange={e => this.setState({ amenityNotes: e.target.value })}
              value={this.state.amenityNotes}
              multiline
            />
          </div>
        </div>
      </div>
    );
  };
};

export default (BookAmenityDialog = connect(mapStateToProps, {
  tenants,
  getActiveLeaseOfUnit,
  ...bookings,
  ...siteEventActions,
  getProperties,
  getAmenities,
  selectedTenantID,
  getAmenity,
})(BookAmenityDialog));
